@if (assistantAvailable()) {
	<div class="paneel">
		<span class="kop">Wat wil je onderzoeken?</span>
		<p class="uitleg">
			Stel je vraag in gewone taal en de CumLaude Assistent helpt je bij het kiezen van het juiste dashboard, filters en
			groeperingen. De assistent is nog experimenteel, dus antwoorden kunnen incorrect zijn. Laat met 👍 of 👎 weten wat je van
			een antwoord vindt, dat helpt ons de assistent te verbeteren.
		</p>
		<app-button (clickit)="openChat()" icon="ai-search">Stel je vraag</app-button>
	</div>
}
